import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { IOption } from 'src/app/ui/interfaces/option';
import { BasePageComponent } from '../base-page';
import { HttpService } from 'src/app/services/http/http.service';
import { FormBuilder } from '@angular/forms';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2'
import { Spinkit } from 'ng-http-loader'; //
import { Router } from '@angular/router'

@Component({
  selector: 'app-restaurant-setting',
  templateUrl: './restaurant-setting.component.html',
  styleUrls: ['./restaurant-setting.component.scss']
})
export class RestaurantSettingComponent extends BasePageComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;
  data: IOption[];
  icons: string[];
  countries: string[];
  allDiestpref = [];
  allergens = [];
  allergenceArray = [];
  changeColordiet = []
  diestPrefArray = [];
  restoID;
  restoDeatils;
  restaurant_coupan_status
  errorMessage;
  getDetails;
  name;
  serviceableStatus
  resto: any;
  rstoName: any;
  rstoAdd: any;
  rstoAllergenMsg: any;
  rstoID;
  rstopocName: any;
  servicecharge: any;
  pocID: any;
  status_active_none: boolean = true;
  status_active_none_allergens_active: boolean = true;
  status_active_none_allergens_inactive: boolean = false;
  status_active_dietary: boolean = true;
  status_inactive_dietary: boolean = false;
  restaurant_id: any;
  rstoEmail: any;
  restaurant_image: any;
  spice_tollerence_level
  spiceLevel: string;
  table: any;
  telephone: any;
  detailsData: { restaurant_name: any; poc_name: any; poc_id: any; no_of_tables: any; restaurant_address: any; restaurant_telephone: any; spice_tollerence_level: any; service_charge: any; coupan_percent: any; waiting_time: any; allergens_msg:any };
  detailsData_resto: { restaurant_name: any; poc_name: any; poc_id: any; no_of_tables: any; restaurant_address: any; restaurant_telephone: any; spice_tollerence_level: any; service_charge: any; waiting_time: any, allergens_msg:any }
  statusClass = 'not-active';
  statusClasses = 'not-active';
  nameallergens
  activeStatus
  diestPrefArrayName = []
  allergenceArrayName = []
  getRestoAllergence = [];
  allergensId
  dietaryId
  statusNone
  restaurant_coupan_value
  data_allergens = []
  isReadOnly: boolean;
  restaurant_online_status
  errortext = '0'
  nutri_info_value
  hide_spice_tollrance
  coupan_value
  activeDietary = [];
  mainDie
  restaurant_wt
  value_dietary: number;
  value_allgerns: number;

  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {
    super(store, httpSv);
  }

  ngOnInit(): void {
    this.isReadOnly = true;
    this.restoID = localStorage.getItem('restoID');
    this.getAllAllergens();
    this.getAllDietry();
    this.getReturant();
    this.getData('assets/data/option.json', 'data');
    this.getAllergenstatus();
    this.getDietarystatus();
  }


  public restrictNumeric(e) {
    if (!((e.keyCode > 95 && e.keyCode < 106)
      || (e.keyCode > 47 && e.keyCode < 58)
      || e.keyCode == 8)) {
      return false;
    }
  }
  logout() {
    this.httpSv.logout().subscribe(
      response => {
        localStorage.clear();
        setTimeout(() => {
          this.router.navigate(['/public/sign-in'])
        })
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllAllergens() {
    this.httpSv.getAllAllergens().subscribe(
      response => {
        if (response['status'] == true) {
          this.allergens = response['result'].data;
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  getAllDietry() {
    this.httpSv.getAllDietry().subscribe(
      response => {
        if (response['status'] == true) {
          this.allDiestpref = response['result'].data;
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }


  getReturant() {
    this.httpSv.getReturant(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {
          this.resto = response['result'].data;
          this.rstoName = this.resto['restaurant_name']
          this.rstoID = this.resto['restaurant_unique_id']
          this.rstoAdd = this.resto['restaurant_address']
          this.rstoAllergenMsg = this.resto['allergens_msg']
          this.rstopocName = this.resto['restaurant_poc_name']
          this.pocID = this.resto['restaurant_poc_number']
          this.rstoEmail = this.resto['restaurant_email']
          this.restaurant_id = this.resto['restaurant_id'];
          this.servicecharge = this.resto['restaurant_service_charge']
          this.restaurant_image = this.resto['restaurant_image'];
          this.table = this.resto['restaurant_no_of_tables'];
          this.telephone = this.resto['restaurant_telephone'];
          this.spice_tollerence_level = response['result'].data.restaurant_spice_tollerence
          this.restaurant_online_status = response['result'].data.restaurant_online_status
          console.log(this.restaurant_online_status)
          this.serviceableStatus = response['result'].data.restaurant_delivery_status;
          this.restaurant_coupan_status = response['result'].data.restaurant_coupan_status
          this.restaurant_coupan_value = response['result'].data.restaurant_coupan_value
          this.nutri_info_value = response['result'].data.restaurant_nutri_status
          this.hide_spice_tollrance = response['result'].data.hide_spice_tolerance
          this.restaurant_wt = this.resto['restaurant_wt'];
          if (this.restaurant_wt == '0' || !this.restaurant_wt) {
            this.restaurant_wt = '0:00'
          } else {
            this.restaurant_wt
          }
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  updateDeliveryStatus(value) {
    this.httpSv.updateDeliveryStatus(value).subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  updateSpiceTollerance(value) {
    const data = {
      restaurant_id: this.restoID,
      hide_spice_tolerance: value
    }
    this.httpSv.updateSpiceTollranceStatus(data).subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  restaurant_coupan(value) {
    this.httpSv.isCoupanAvailiable(value).subscribe(res => {
      if (res['status'] == true) {
        this.ngOnInit();
      }
    });
  }

  restaurantOrderStatusResto(value) {
    let data = {
      restaurant_id: localStorage.getItem('restoID'),
      restaurant_online_status: value
    }
    if (value == 'Active') {
      swal.fire({
        titleText: "Are you sure to enable online orders",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',

      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.httpSv.updateRestaurantStatusActiveInActive(data).subscribe(res => {
            if (res['status'] == 'TRUE') {
              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['configration/restaurantSetting']);
              });
            }
            else {
              this._snackBar.open(res['message'])
              setTimeout(() => {
                this._snackBar.dismiss()
              }, 2000)
            }
          }, err => {
            this._snackBar.open('Oops!! Something went wrong')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000)
          })
        }
        else {
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['configration/restaurantSetting']);
          });
        }
      })
    }
    else if (value == 'Inactive') {
      swal.fire({
        titleText: "Are you sure to disable online orders",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',

      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.httpSv.updateRestaurantStatusActiveInActive(data).subscribe(res => {
            if (res['status'] == 'TRUE') {
              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['configration/restaurantSetting']);
              });
            }
            else {
              this._snackBar.open(res['message'])
              setTimeout(() => {
                this._snackBar.dismiss()
              }, 2000)
            }
          }, err => {
            this._snackBar.open('Oops!! Something went wrong')
            setTimeout(() => {
              this._snackBar.dismiss()
            }, 2000)
          })
        }
        else {
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['configration/restaurantSetting']);
          });
        }
      })
    }
    // this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['configration/restaurantSetting']);
    //  }); 
  }
  Onupdate(rstoName, rstoAdd, rstopocName, pocID, spice_tollerence_level, table, telephone, servicecharge, rstoAllergenMsg) {
    // console.log(this.resto_waittime)
    if (servicecharge === servicecharge && servicecharge % 1 !== 0) {
      this.errortext = '1'
    }
    else {
      this.detailsData_resto = {
        restaurant_name: rstoName,
        poc_name: rstopocName,
        poc_id: pocID,
        no_of_tables: table,
        restaurant_address: rstoAdd,
        restaurant_telephone: telephone,
        service_charge: servicecharge,
        spice_tollerence_level: spice_tollerence_level,
        waiting_time: this.restaurant_wt,
        allergens_msg: rstoAllergenMsg
      }
      this.httpSv.UpdaterestoDetails(this.detailsData_resto).subscribe(
        response => {
          if (response['status'] == true) {
            Swal.fire("Successfully updated")
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['configration/restaurantSetting']);
            })
          }
        }, (err: HttpErrorResponse) => {

          this.errorMessage = err.error.message.restaurant_telephone ? err.error.message.restaurant_telephone + "\n" : "";//only if have an error msg.
          this.errorMessage += err.error.message.restaurant_name ? err.error.message.restaurant_name + "\n" : "";//only if have an error msg.
          this.errorMessage += err.error.message.poc_name ? err.error.message.poc_name : "";
          this.errorMessage += err.error.message.poc_id ? err.error.message.poc_id : "";
          this.errorMessage += err.error.message.spice_tollerence_level ? err.error.message.spice_tollerence_level : "";
          Swal.fire({
            title: this.errorMessage
          }
          );
        });
    }
  }
  Onupdate_resto(rstoName, rstoAdd, rstopocName, pocID, spice_tollerence_level, table, telephone, servicecharge, restaurant_coupan_value,rstoAllergenMsg) {
    // console.log(this.resto_waittime)
    if (servicecharge === servicecharge && servicecharge % 1 !== 0) {
      this.errortext = '1'
    }
    else {
      this.detailsData = {
        restaurant_name: rstoName,
        poc_name: rstopocName,
        poc_id: pocID,
        no_of_tables: table,
        restaurant_address: rstoAdd,
        restaurant_telephone: telephone,
        service_charge: servicecharge,
        spice_tollerence_level: spice_tollerence_level,
        coupan_percent: restaurant_coupan_value,
        waiting_time: this.restaurant_wt,
        allergens_msg: rstoAllergenMsg
      }

      this.httpSv.UpdaterestoDetails(this.detailsData).subscribe(
        response => {
          if (response['status'] == true) {
            Swal.fire("Successfully updated")
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
              this.router.navigate(['configration/restaurantSetting']);
            })
          }
          else {
            Swal.fire("Something Went Wrong")
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message.restaurant_telephone ? err.error.message.restaurant_telephone + "\n" : "";//only if have an error msg.
          this.errorMessage += err.error.message.restaurant_name ? err.error.message.restaurant_name + "\n" : "";//only if have an error msg.
          this.errorMessage += err.error.message.poc_name ? err.error.message.poc_name : "";
          this.errorMessage += err.error.message.poc_id ? err.error.message.poc_id : "";
          this.errorMessage += err.error.message.spice_tollerence_level ? err.error.message.spice_tollerence_level : "";
          Swal.fire({
            title: this.errorMessage
          }
          );
        });
    }
  }

  AllergensRemove() {
    this.allergenceArray = [];
    this.allergenceArrayName = []
    this.httpSv.deleteAllergens().subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
          this.status_active_none_allergens_active = true
          this.status_active_none_allergens_inactive = false
        }
      }
      , (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^[0-9]*\.{1}?[0-9]*$/;
    if (!reg.test(input)) {
      e.preventDefault();
    }
  }


  //For restaurant allergens check
  getAllergenstatus() {
    this.httpSv.getAllergenstatus().subscribe(
      response => {
        if (response['status'] == true) {
          this.data_allergens = response['result'].data
          this.value_allgerns = this.data_allergens.filter(res => res.restaurant_allergens_status == 'Active').length
          if (this.value_allgerns == 0) {
            this.status_active_none_allergens_active = true
            this.status_active_none_allergens_inactive = false
          }
          else {
            this.status_active_none_allergens_active = false
            this.status_active_none_allergens_inactive = true
          }
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 400) {
          this.status_active_none_allergens_active = true
          this.status_active_none_allergens_inactive = false
        }
        else if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  setAllergenceActiveClass() {
    this.status_active_none = false
    if (this.allergenceArray.length == 0) {
      this.AllergensRemove()
    }
    else {
      this.statusClasses = 'active';
    }
  }

  toggleSelectedAllergence(item, itemAll, i) {
    if (this.allergenceArray.indexOf(item) == -1) {
      this.allergenceArray.push(item)
      this.allergenceArrayName.push(itemAll)
      this.httpSv.upDateAllergence(item).subscribe(
        response => {
          if (response['status'] == true) {
            this.status_active_none_allergens_active = false
            this.status_active_none_allergens_inactive = true
            this.getAllergenstatus()
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      )
    }
    else {
      const index = this.allergenceArray.indexOf(item)
      this.allergenceArray.splice(index, 1)
      this.nameallergens = this.allergenceArrayName.splice(index, 1)
      this.httpSv.upDateAllergenceinactive(item).subscribe(
        response => {
          if (response['status'] == true) {
            this.status_active_none_allergens_active = false
            this.status_active_none_allergens_inactive = true
            this.ngOnInit();
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      )

    }
  }

  inactiveAllegens(item, itemAll, i) {
    this.httpSv.upDateAllergenceinactive(item).subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  dietRemove() {
    this.diestPrefArray = []
    this.changeColordiet = []
    this.diestPrefArrayName = []
    this.httpSv.deletedietary().subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
          this.status_active_dietary = true;
          this.status_inactive_dietary = false;
        }

      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }

      }
    )
  }
  setActiveClass() {
    if (this.diestPrefArray.length == 0) {
      this.dietRemove()
    }
  }
  getDietarystatus() {
    this.httpSv.getDietarystatus().subscribe(
      response => {
        if (response['status'] == true) {
          this.status_active_dietary = false
          this.status_inactive_dietary = true
          this.activeDietary = response['result'].data
          this.value_dietary = this.activeDietary.filter(res => res.restaurant_dietary_status == 'Active').length
          if (this.value_dietary == 0) {
            this.status_active_dietary = true
            this.status_inactive_dietary = false
          }
          else {
            this.status_active_dietary = false
            this.status_inactive_dietary = true
          }
        }

      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 400) {
          this.status_active_dietary = true
          this.status_inactive_dietary = false
        }
        else if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  addAllDiet(item, itemAll, i) {
    if (this.diestPrefArray.indexOf(item) == -1) {
      this.diestPrefArray.push(item)
      this.diestPrefArrayName.push(itemAll)
      this.httpSv.upDateDietary(item).subscribe(
        response => {
          if (response['status'] == true) {
            this.status_active_dietary = false
            this.status_inactive_dietary = true
            this.getDietarystatus();
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      )

    }
    else {
      const index = this.diestPrefArray.indexOf(item)
      this.diestPrefArray.splice(index, 1)
      this.diestPrefArrayName.splice(index, 1)
      this.httpSv.inactiveDietary(item).subscribe(
        response => {
          if (response['status'] == true) {
            this.status_active_dietary = false
            this.status_inactive_dietary = true
            this.ngOnInit();
          }
        }, (err: HttpErrorResponse) => {
          this.errorMessage = err.error.message;
          if (err.status == 401 || err.status == 500) {
            this.logout();
          }
        }
      )
    }
  }

  inactiveDietary(item, itemAll, i) {
    this.diestPrefArray.push(item)
    this.diestPrefArrayName.push(itemAll);
    this.httpSv.inactiveDietary(item).subscribe(
      response => {
        if (response['status'] == true) {
          this.ngOnInit();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }

  Onclickbutton() {
    this.router.navigate(['horizontal/main']);
  }
  nutri_info(value) {
    this.httpSv.isNutriAvailiable(value).subscribe(res => {
      if (res['status'] == true) {
        this.ngOnInit();
      }
    }, (err: HttpErrorResponse) => {
      this.errorMessage = err.error.message;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
    })
  }
  resto_waittime
  setTime(picker) {
    this.restaurant_wt = picker
  }


}



